import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/input-close-btn.png'
import _imports_1 from '@/assets/icons/check-icon.png'
import _imports_2 from '@/assets/icons/uncheck-icon.png'
import _imports_3 from '@/assets/images/enroll-popup-close-btn.png'


const _withScopeId = n => (_pushScopeId("data-v-064556f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "enroll-popup" }
const _hoisted_2 = { class: "enroll-tit" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "form-wrapper" }
const _hoisted_5 = { class: "phone-group input-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "手机号", -1))
const _hoisted_7 = ["readonly"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "captcha-group input-group"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "验证码", -1))
const _hoisted_12 = { class: "send-btn" }
const _hoisted_13 = { class: "checkbox-wrap" }
const _hoisted_14 = { class: "checkbox" }
const _hoisted_15 = {
  key: 0,
  class: "hook-icon",
  src: _imports_1
}
const _hoisted_16 = {
  key: 1,
  class: "hook-icon",
  src: _imports_2
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点击提交即视为同意", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "other-tip" }, "*优惠信息由商家提供，请以实际为准", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_btn = _resolveComponent("custom-btn")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "coupon-popup-wrapper",
    onTouchmove: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", {
      class: "mask",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleEnrollPopup(false)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.activityInfo.popTitleImgUrl,
          alt: ""
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['enroll-box', { big: _ctx.captchaNeedVerify }])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              class: "phone-input",
              readonly: _ctx.isReadOnly,
              ref: "phoneInputRef",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.postForm.phone) = $event)),
              maxlength: "11",
              type: "tel",
              placeholder: "请输入您的手机号",
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleKeyInput($event, 'phone', 11)))
            }, null, 40, _hoisted_7), [
              [_vModelText, _ctx.postForm.phone]
            ]),
            _withDirectives(_createElementVNode("div", {
              class: "input-close-btn",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearPhone && _ctx.clearPhone(...args)))
            }, _hoisted_9, 512), [
              [_vShow, _ctx.postForm.phone.length > 0]
            ])
          ]),
          (_ctx.captchaNeedVerify)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  class: "captcha-input",
                  type: "text",
                  placeholder: "请输入验证码",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.postForm.captcha) = $event)),
                  onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleKeyInput($event, 'captcha', 6)))
                }, null, 544), [
                  [_vModelText, _ctx.postForm.captcha]
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_custom_btn, {
                    size: 'small',
                    bgColor: _ctx.activityInfo.assistRgb,
                    onClick: _ctx.getCaptcha
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(!_ctx.timer ? '发送' : _ctx.resTime + 's'), 1)
                    ]),
                    _: 1
                  }, 8, ["bgColor", "onClick"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "submit-btn",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
          }, [
            _createVNode(_component_custom_btn, {
              size: 'big',
              bgColor: _ctx.activityInfo.subjectRgb,
              animationName: 'heart'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.enrollSgInfo.type === 1 ? '预约试驾' : '马上领取'), 1)
              ]),
              _: 1
            }, 8, ["bgColor"])
          ]),
          _createElementVNode("div", {
            class: "statement-tip1",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.statementClick && _ctx.statementClick(...args)))
          }, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                (_ctx.checkBoxNeedVerify)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                  : (_openBlock(), _createElementBlock("img", _hoisted_16))
              ]),
              _hoisted_17,
              _createElementVNode("a", {
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toLinkStatement && _ctx.toLinkStatement(...args))),
                href: "javascript:;"
              }, "《个人信息披露及保护声明》")
            ])
          ]),
          _hoisted_18
        ])
      ], 2),
      _createElementVNode("div", {
        class: "enroll-close-btn",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toggleEnrollPopup(false)))
      }, _hoisted_20)
    ])
  ], 544)), [
    [_vShow, _ctx.isShowPopup]
  ])
}